/* global PLATFORM, G */
import { isArr } from 'lib/util'

const descriptor = Symbol('hook::module::multiCreate').toString()

/**
 * Multi Create Hook
 *
 * Configures the {@link TabBar} on mobile, to show a menu with all create actions
 * defined in the module configuration.
 *
 * @param {Gaia.AppModule.Spec} obj  the current module composition object
 * @returns {function(...[*]): *[]}
 */
const multiCreate = obj => (...args) => {
  const actionUI = obj[G.STATE][G.ACTION][G.UI]

  if (!actionUI.create || !isArr(actionUI.create) || PLATFORM !== 'mobile') {
    return args
  }

  try {
    const createEvents = obj[G.EVENTS].onCreate
    const onCreate = createEvents[Object.keys(createEvents)[0]] // Using first event
    const component = obj[G.STATE][G.ACTION][G.COMPONENT]
    const onCreateDefaultPartial = onCreate(obj, component)

    actionUI.create = actionUI.create.filter((createConfig) => {
      try {
        obj[G.ADAPTER][G.ACL].create(createConfig?.acl)
        return true
      } catch (e) {
        return false
      }
    }).map((createConfig) => {
      const onCreatePartial = createConfig?.events?.onCreate
        ? createEvents[createConfig.events.onCreate](obj, component)
        : onCreateDefaultPartial

      return { ...createConfig, onCreate: onCreatePartial }
    })
  } catch (e) {
    throw Error(`${obj._name} ${descriptor} - ${e.message}`)
  }

  return args
}

export default multiCreate
